"use client";
import React, { useRef } from "react";
import Image from "next/image";
import Section from "@/components/static/Section";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/static/Tabs";
import { SectionPadding, HeadlineProps, ImageProps, ButtonProps } from "@/lib/types";
import { useScroll, useTransform, motion } from "framer-motion";

type Content = {
    settings: {
        padding: SectionPadding;
    };
    images: [
        {
            images: ImageProps[];
        }
    ];
};

export default function Layout_414({ content }: { content: Content }) {
    const sectionRef = useRef<HTMLDivElement>(null);
    const { scrollYProgress } = useScroll({
        target: sectionRef,
        offset: ["start center", "end start"],
    });

    const xPartOne = useTransform(scrollYProgress, [0, 1], ["1%", "50%"]);
    const xPartTwo = useTransform(scrollYProgress, [0, 1], ["-1%", "-50%"]);

    return (
        <Section
            dataComponent='Layout_414'
            settings={content.settings}
            className='overflow-hidden px-[5%] py-16 md:py-24 lg:py-28'
        >
            <div className='container' ref={sectionRef}>
                <div className='flex flex-col items-center'>
                    <div className='flex w-screen flex-col items-center gap-4 overflow-hidden'>
                        {content.images.map((image, key) => (
                            <div key={key}>
                                <motion.div
                                    className='flex size-full flex-nowrap items-center justify-center gap-4'
                                    style={{
                                        translateX: key % 2 === 0 ? xPartOne : xPartTwo,
                                    }}
                                >
                                    {Array(1)
                                        .fill(image.images)
                                        .flat()
                                        .map((image, key) => (
                                            <div
                                                key={key}
                                                className='w-[40vw] flex-none md:w-[30vw]'
                                            >
                                                <Image
                                                    className='aspect-[4/3] w-full object-cover rounded-2xl'
                                                    src={image.url}
                                                    alt={image.alt}
                                                    height={image.height}
                                                    width={image.width}
                                                />
                                            </div>
                                        ))}
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Section>
    );
}
